import React from 'react'
import { DataGrid } from '@material-ui/data-grid'
import { makeStyles } from '@mui/styles'
import { DeleteOutline, Search } from "@mui/icons-material";
import { IconButton, Grid } from '@mui/material'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useConfirm } from 'material-ui-confirm'
import { deleteBookedLessonByAdmin } from '../../actions/learningScheduleForStudent'
import { toast } from 'react-toastify'
import displayBookedLessonEndingTimeForStudent from '../../utils/displayBookedLessonEndingTimeForStudent'

const useStyles = makeStyles(theme => ({
  bookedLessonsTable: {
    height: 400, width: '100%',
    backgroundColor: 'white'
  }
}))

const BookedLessonsList = ({ bookedLessons }) => {
  const classes = useStyles()

  const confirm = useConfirm()

  const dispatch = useDispatch()

  const handleDelete = (bookedLessonId) => {
    confirm({
      description: 'Nhấn đồng ý sẽ xóa bài học',
      title: 'Bạn có chắc không?'
    }).then(() => {
      dispatch(deleteBookedLessonByAdmin(bookedLessonId))
      toast.success('Đã xóa bài học thành công')
    }).catch(() => { })
  }

  const columns = [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'student', headerName: 'Học sinh', width: 140 },
    { field: 'teacher', headerName: 'Giáo viên', width: 140 },
    { field: 'finishingTime', headerName: 'Giờ kết thúc', width: 300 },
    { field: 'status', headerName: 'Tình trạng', width: 170 },
    {
      field: 'actions', headerName: '', width: 150, renderCell: (params) => {
        return <>
          <Grid container justifyContent='center' alignItems='center' spacing={3}>
            <Grid item>
              <IconButton
                component={Link}
                to={`/admin/bookedLessonDetails/${params.value}`}
                size="large">
                <Search color='black' />
              </IconButton>
            </Grid>

            <Grid item>
              <IconButton component={Link} size="large">
                <DeleteOutline
                  className="productListDelete"
                  onClick={() => handleDelete(params.value)}
                />
              </IconButton>
            </Grid>
          </Grid>
        </>;
      },
    }
  ]

  let rows = []
  if (bookedLessons.length > 0) {
    rows = bookedLessons.map((bookedLesson, idx) => {
      return {
        id: idx + 1, student: bookedLesson.user.name, teacher: bookedLesson.teacher.name, finishingTime: displayBookedLessonEndingTimeForStudent(bookedLesson), status: bookedLesson.state, actions: bookedLesson._id
      }
    })
  }

  return (
    <div className={classes.bookedLessonsTable}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        checkboxSelection
        disableSelectionOnClick
      />
    </div>
  )
}

export default BookedLessonsList
